@if(sources && sources.length > 0) {
<div class="inline-block">
  <app-menu #sourcesMenu [items]="sourcesMenuItems" [attr.step-id]="'sources-menu'">
    <div
      class="text-xs rounded-full bg-gray-200/50 px-2 py-1 cursor-pointer hover:bg-zinc-900 hover:text-white transition-colors duration-200"
      (click)="showSourcesPanel($event)">
      <span>{{ displayText }}</span>
    </div>
  </app-menu>
</div>
}